import { z } from 'zod'
import { dateSchema } from '~/shared/lib/schemas'
import { Car } from './car'
import { ApiModel } from './core'

const schema = z.object({
  plateNumber: z.string(),
  series: z.string().optional().nullable(),
  number: z.string().optional().nullable(),
  issuedDate: dateSchema,
  expirationDate: dateSchema.optional().nullable(),
  issuedBy: z.string().optional().nullable(),
  data: z
    .object({
      isTemporaryNumber: z.boolean().optional().nullable(),
    })
    .optional()
    .nullable(),

  files: z
    .object({
      id: z.string(),
      name: z.string(),
      filepath: z.string().url(),
      preview: z.string().url(),
    })
    .array()
    .optional(),

  createdAt: dateSchema,
  updatedAt: dateSchema.optional(),
})

export type StsDocumentAttributes = z.infer<typeof schema>

export class StsDocument extends ApiModel<typeof schema> {
  static jsonApiType = 'sts-documents'

  static schema = schema

  setCar(id: UniqueId) {
    this.setRelation('car', new Car({}, id))
  }

  getCreatedAt(): string {
    return this.getAttribute('createdAt')
  }

  getFiles(): StsDocumentAttributes['files'] {
    return this.getAttribute('files')
  }
}
